import { cardsData } from '@/mocks/home';

const cardImages = [
  'https://readdy.ai/api/search-image?query=Editorial%20entertainment%20news%20illustration%20with%20modern%20minimal%20style%2C%20warm%20coral%20and%20soft%20golden%20accents%2C%20clean%20abstract%20composition%2C%20trendy%20magazine%20layout%20aesthetic%2C%20young%20audience%20targeted%20visual%2C%20soft%20lighting%20with%20subtle%20gradients&width=800&height=500&seq=card-1-51cg&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20photography%20style%20art%20of%20television%20studio%20setting%20with%20dramatic%20lighting%2C%20abstract%20media%20production%20visual%2C%20soft%20coral%20and%20amber%20gradients%2C%20modern%20magazine%20aesthetic%2C%20high%20detail%2C%20clean%20composition&width=800&height=500&seq=card-2-51cg&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Digital%20social%20media%20influencer%20aesthetic%20abstract%20art%2C%20bold%20warm%20red%20and%20gold%20color%20scheme%2C%20modern%20editorial%20design%2C%20trendy%20minimal%20composition%2C%20soft%20studio%20lighting%20effect%2C%20high%20quality%20visual&width=800&height=500&seq=card-3-51cg&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20abstract%20art%20with%20warm%20projector%20light%20effect%2C%20soft%20coral%20pink%20and%20golden%20hues%2C%20modern%20editorial%20magazine%20style%2C%20clean%20minimal%20composition%2C%20high%20detail%20digital%20illustration&width=800&height=500&seq=card-4-51cg&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Luxury%20brand%20fashion%20abstract%20editorial%20art%20with%20warm%20neutrals%20and%20soft%20rose%20gold%20accents%2C%20modern%20minimal%20composition%2C%20trendy%20magazine%20aesthetic%2C%20clean%20studio%20lighting%2C%20high%20quality%20visual&width=800&height=500&seq=card-5-51cg&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Music%20festival%20abstract%20editorial%20illustration%20with%20vibrant%20warm%20colors%20and%20soft%20gradients%2C%20modern%20magazine%20layout%20style%2C%20minimal%20design%2C%20soft%20golden%20hour%20lighting%2C%20high%20detail&width=800&height=500&seq=card-6-51cg&orientation=landscape',
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          吃瓜速递
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">最新最热的吃瓜内容，实时更新</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((card, i) => (
            <article
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={cardImages[i]}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-500 text-background-50 text-[10px] font-bold rounded whitespace-nowrap">
                  {card.category}
                </span>
              </div>

              {/* Content */}
              <div className="p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-950 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {card.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{card.time}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500"></i>
                    {card.heat}热度
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}